import { FunctionComponent} from 'preact';
import Favicon from './Favicon';

import MoreButton from '../../../../shared/MoreButton';
import styles from './../styles.module.scss';

interface TileProps {
  item;
  onClickMore: () => void;
  isNew: boolean;
}

const UrlTile: FunctionComponent<TileProps> = ({
  item,
  onClickMore,
  isNew,
}: TileProps) => (
  <div className={`${styles.topPageContainer} ${isNew ? styles.animate : ''}`}>
    <MoreButton className={styles.moreButton} onClick={onClickMore} />
    <a className={styles.topPage} href={item.url}>
      <div className={styles.icon}>
        <Favicon domain={item.url} />
      </div>
      <span className={styles.label}>{item.title}</span>
    </a>
  </div>
);

export default UrlTile;
